/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Image_FileInputs */

const en_select_image_file = /** @type {(inputs: Select_Image_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an image file`)
};

const es_select_image_file = /** @type {(inputs: Select_Image_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un archivo de imagen`)
};

/**
* | output |
* | --- |
* | "Please select an image file" |
*
* @param {Select_Image_FileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_image_file = /** @type {((inputs?: Select_Image_FileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Image_FileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_image_file(inputs)
	return es_select_image_file(inputs)
});